import axios from "./index";

type ConsultationPreprocessingRequestApiResponse = {
  isComplete: boolean;
  questions: Array<{
    id: number;
    question: string;
    quote: string | null;
  }>;
};

type FetchParams = {
  consultationId?: number | string;
};

const consultationPreprocessingRequestsApi = {
  fetch({ consultationId }: FetchParams): Promise<ConsultationPreprocessingRequestApiResponse | undefined> {
    if (!consultationId) return Promise.resolve(undefined);

    return axios
      .get("/api/v1/consultation_preprocessing_requests", {
        params: { anytime_consultation_id: consultationId },
      })
      .then((response) => response?.data as ConsultationPreprocessingRequestApiResponse | undefined);
  },
};

export default consultationPreprocessingRequestsApi;
